import React from "react";
import { usePermission } from "./usePermission";

interface ProtectedMenuItemProps {
  children: React.ReactNode;
  requiredPermissions?: string[];
  fallback?: React.ReactNode;
}

/**
 * Protected Menu Item Component
 * Wraps menu items and conditionally renders them based on permissions
 * Returns null (hides menu item) if user doesn't have access
 */
export const ProtectedMenuItem: React.FC<ProtectedMenuItemProps> = ({
  children,
  requiredPermissions = [],
  fallback = null,
}) => {
  const { canSeeMenuItem, isFullAccess, user } = usePermission();

  // Don't render until user is loaded (prevents flash of hidden content)
  if (!user) {
    return null;
  }

  // super_admin and admin can see everything
  if (isFullAccess) {
    return <>{children}</>;
  }

  // Check if user can see this menu item
  const canSee = canSeeMenuItem(requiredPermissions);

  if (!canSee) {
    // Return fallback or null to hide the menu item
    return <>{fallback}</>;
  }

  return <>{children}</>;
};
